export default __webpack_public_path__ + "static/media/DRHS.5dcfa376.png";